import Vue from 'vue';

/**
 * Global Modal Bus
 */
export const ModalBus = new Vue({
  data: {
    openedModalsStack: [],
  },
  created() {
    this.$on('modal-opened', (vue) => {
      this.openedModalsStackPush(vue);
    });
    this.$on('modal-closed', (vue) => {
      if (this.openedModalsStackIncludes(vue)) {
        this.openedModalsStackRemove(vue);
      }
    });
  },
  methods: {
    detectEscapeAndCloseModal: function detectEscapeAndCloseModal(e) {
      if (e.key === 'Escape') {
        this.openedModalsStackPop();
      }
    },
    addEscapeListenerIfNotAdded() {
      if (this.openedModalsStack.length === 0) {
        window.addEventListener('keyup', this.detectEscapeAndCloseModal);
      }
    },
    removeEscapeListenerIfNotRemoved() {
      if (this.openedModalsStack.length === 0) {
        window.removeEventListener('keyup', this.detectEscapeAndCloseModal);
      }
    },
    openedModalsStackIncludes(modalRef) {
      return this.openedModalsStack.includes(modalRef);
    },
    openedModalsStackPush(modalRef) {
      this.addEscapeListenerIfNotAdded();
      this.openedModalsStack.push(modalRef);
    },
    openedModalsStackPop() {
      const modal = this.openedModalsStack[this.openedModalsStack.length - 1];

      if (modal && !modal.localPersistent) {
        this.openedModalsStack.pop()
          .hide();
      }
      this.removeEscapeListenerIfNotRemoved();
    },
    openedModalsStackRemove(modalRef) {
      _.remove(this.openedModalsStack, e => e._uid === modalRef._uid);
      this.removeEscapeListenerIfNotRemoved();
    },
  },
});
